import { AdminService } from './../../../services/admin.service';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from './../../../services/user.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { first } from 'rxjs/internal/operators/first';
import * as jquery from 'jquery';
import { map, tap } from 'rxjs/operators';
import { UserNavigationComponent } from 'src/app/partials/navigation/user-navigation/user-navigation.component';
import { Role } from 'src/app/models';

declare var require: any;

@Component({
  selector: 'app-edit-details',
  templateUrl: './edit-details.component.html',
  styleUrls: ['./edit-details.component.scss']
})
export class EditDetailsComponent implements OnInit {

  @ViewChild('fileInput') fileInput;
  @ViewChild(UserNavigationComponent) userNavigation;

  user: any;
  editForm: FormGroup;
  submitted = false;
  success = false;
  error = false;
  errorMsg: string;
  fileToUpload: any;
  preloaderImage = require('../../../../assets/images/loader-big.svg');
  imageUploadLabel = 'Upload New';
  imageSourcePreview = '';
  modalText = 'Loading...';
  nonAdminRoles = [Role.Individual, Role.Manager, Role.Employee];

  constructor(
    private userService: UserService,
    private adminService: AdminService,
    public authService: AuthService,
    private route: ActivatedRoute,
    private pageTitleService: Title) { }

  ngOnInit(): void {
    this.setPageTitle();
    this.setFormControls();

    const currentRole = this.authService.currentUserValue.role;
    if (currentRole && this.nonAdminRoles.indexOf(currentRole) >= 0) {
      this.loadData();
    } else {
      this.authService.getTokenDetails(this.authService.tokenValue)
        .subscribe(response => {
          if (response && response.data.role === Role.Admin) {
            this.loadAdminData();
          } else {
            this.loadData();
          }
        });
    }

    let top = document.getElementById('top');
    if (top !== null) {
      top.scrollIntoView();
      top = null;
    }
  }

  loadData() {

    // Show progress modal
    this.showProgressModal();

    this.userService.getProfile()
      .pipe(

        // Get User Details
        map(user => user.data.user),
        tap(user => {
          this.userNavigation.user = user;
          this.user = user;

          // Form Controls
          this.f.firstName.setValue(user?.first_name);
          this.f.lastName.setValue(user?.last_name);
        }),

      )
      .subscribe(
        response => {
          if (response) {
            setTimeout(() => {
              // hide progress modal
              this.hideProgressModal();
            }, 500);
          }
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  loadAdminData() {

    // Show progress modal
    this.showProgressModal();

    this.adminService.getProfile()
      .pipe(

        // Get User Details
        map(user => user.data.user),
        tap(user => {
          this.userNavigation.user = user;
          this.user = user;

          // Form Controls
          this.f.firstName.setValue(user?.first_name);
          this.f.lastName.setValue(user?.last_name);
        }),

      )
      .subscribe(
        response => {
          if (response) {
            setTimeout(() => {
              // hide progress modal
              this.hideProgressModal();
            }, 500);
          }
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  onImageFileInputChange(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {

      const [file] = event.target.files;
      this.imageUploadLabel = file.name;

      // Get the image source preview
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageSourcePreview = reader.result as string;
      };
    }
  }

  deleteUpload() {
    this.fileInput.nativeElement.value = '';
    this.imageSourcePreview = '';
    this.imageUploadLabel = 'Upload New';
  }

  setPageTitle() {
    this.pageTitleService.setTitle(this.route.snapshot.data.title || 'Edit Details');
  }

  setFormControls() {
    this.editForm = new FormGroup({
      firstName: new FormControl('', [
        Validators.required
      ]),
      lastName: new FormControl('', [
        Validators.required
      ])
    });
  }

  // Convenience getter for easy access to form fields
  get f() { return this.editForm.controls; }

  onSubmit() {
    this.submitted = true;

    // Stop here if there's form errors
    if (this.editForm.invalid) {
        return;
    }

    const fi = this.fileInput.nativeElement;
    if (fi.files && fi.files[0]) {
      this.fileToUpload = fi.files[0];
    }

    // Show progress modal
    this.showProgressModal();
    this.modalText = 'Saving...';

    const currentRole = this.authService.currentUserValue.role;
    if (currentRole && this.nonAdminRoles.indexOf(currentRole) >= 0) {
      this.updateNormalUser();
    } else {
      this.authService.getTokenDetails(this.authService.tokenValue)
        .subscribe(response => {
          if (response && response.data.role === Role.Admin) {
            this.updateAdminUser();
          } else {
            this.updateNormalUser();
          }
        });
    }

  }

  private updateNormalUser() {
    this.userService.updateDetails(
      this.f.firstName.value,
      this.f.lastName.value,
      this.fileToUpload)
      .pipe(first())
      .subscribe(
        data => {
          // hide progress modal
          this.hideProgressModal();

          if (!data.success) {
            this.error = true;
            // Hides the error message after 5 seconds
            setTimeout(function() {
              this.error = false;
            }.bind(this), 5000);
            return;
          }

          this.success = true;

          // Deletes recent upload and hide upload button
          this.deleteUpload();

          // Updates user data on the navigation
          this.userNavigation.user = data?.user;
          this.user = data?.user;

          // Hides success after 3 seconds
          setTimeout(() => {
            this.success = false;
          }, 5000);

        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        });
  }

  private updateAdminUser() {
    this.adminService.updateDetails(
      this.f.firstName.value,
      this.f.lastName.value,
      this.fileToUpload)
      .pipe(first())
      .subscribe(
        data => {
          // hide progress modal
          this.hideProgressModal();

          if (!data.success) {
            this.error = true;
            // Hides the error message after 5 seconds
            setTimeout(function() {
              this.error = false;
            }.bind(this), 5000);
            return;
          }

          this.success = true;

          // Deletes recent upload and hide upload button
          this.deleteUpload();

          // Updates user data on the navigation
          this.userNavigation.user = data?.user;
          this.user = data?.user;

          // Hides success after 3 seconds
          setTimeout(() => {
            this.success = false;
          }, 5000);

        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        });
  }

  private showProgressModal() {
    jquery('#loaderSpin').show();
  }

  private hideProgressModal() {
    jquery('#loaderSpin').hide();
  }

}
